import styled from 'styled-components';
import { PaginationReadoutItemMixin } from '../../mixins/components/PaginationItemMixin';

/**
 * Used by the `Pagination` component to house the "Page x of x" label that appears on
 * smaller screens.
 *
 * @since 7.42.0
 */
var PaginationReadoutItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "PaginationReadoutItem",
  componentId: "c11n-8-107-0__sc-1dud86-0"
})(["", ""], PaginationReadoutItemMixin);
PaginationReadoutItem.displayName = 'PaginationReadoutItem';

/** @component */
export { PaginationReadoutItem };